/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    UniversityCenterDTO,
    UniversityCenterDTOFromJSON,
    UniversityCenterDTOToJSON,
} from '../models';

/**
 * 
 */
export class UniversityCenterApi extends runtime.BaseAPI {

    /**
     */
    async apiUniversityCenterGetAllUniversityCentersGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<UniversityCenterDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/UniversityCenter/GetAllUniversityCenters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UniversityCenterDTOFromJSON));
    }

    /**
     */
    async apiUniversityCenterGetAllUniversityCentersGet(initOverrides?: RequestInit): Promise<Array<UniversityCenterDTO>> {
        const response = await this.apiUniversityCenterGetAllUniversityCentersGetRaw(initOverrides);
        return await response.value();
    }

}
